<script>
  // @ts-check
  import Grid from "../../atoms/Grid.svelte";
  import { getContext } from "svelte";
  import ListItem from "./ListItem.svelte";

  /** @type { string } */
  let className = "";
  export { className as class };

  /**
   * Primarily used for testing
   * @type {string}
   */
  export let id = undefined;

  /**
   * Determines the layout of the list. It can be either "fullWidth" for a full-width list (4 column on larger breakpoints) or "inset" for a list (2 columns on larger breakpoints) with margins.
   * @type {"inset" | "fullWidth"}
   */
  export let columnsVariant = "fullWidth";

  if (getContext("CenteredLayout")) {
    columnsVariant = "inset";
  }

  /**
   * Determines the type of the list. It can be either "ordered" for a numbered list or "unordered" for a default list without numbers.
   * @type {"unordered" | "ordered"}
   */
  export let variant = "unordered";

  /**
   * An array of ListItems
   * @type {ListItemType[]}
   */
  export let data = [];

  const subGridColumns =
    columnsVariant === "fullWidth"
      ? null
      : /** @type {const} **/ ({ mobile: 4, tablet: 8, desktop: 6 });

  const listItemClass =
    columnsVariant === "fullWidth" ? "md:odd:col-start-3 lg:odd:col-start-auto" : "md:col-span-3";
</script>

<div {id} class={className}>
  <Grid
    {subGridColumns}
    gridElement={variant === "ordered" ? "ol" : "ul"}
    gridClass=" gap-y-7.5 md:gap-y-15 lg:gap-y-20 xl:gap-y-25"
  >
    {#each data as { headline, body, component, componentProps }, index (index)}
      <li
        class="col-full-width border-t-thin pt-6 md:col-span-4 lg:col-span-3 xl:pt-7.5 {listItemClass}"
      >
        <ListItem label={headline} number={variant === "ordered" ? index + 1 : undefined}>
          {#if component}
            <svelte:component this={component} {...componentProps} />
          {:else if !!body}
            {body}
          {/if}
        </ListItem>
      </li>
    {/each}
  </Grid>
</div>
